function hw(pairs) {
  const weights = new Array(24).fill(0);
  pairs.forEach(([hour, value]) => {
    weights[hour] = value;
  });
  return weights;
}

const DEFAULT_SOURCE_CATALOG = {
  weekday_slots: [
    { id: 'sl_sleep', act_id: 'sleep', label: 'Sleep', emoji: '🌙', win_start: 22, win_end: 30, dur_min: 360, dur_max: 480, priority: 10, is_sleep: true },
    { id: 'sl_wake', act_id: 'morning_routine', label: 'Morning Routine', emoji: '🌅', win_start: 6, win_end: 9, dur_min: 20, dur_max: 40, priority: 9, is_sleep: false },
    { id: 'sl_bfast', act_id: 'eating', label: 'Breakfast', emoji: '🍳', win_start: 7, win_end: 10, dur_min: 15, dur_max: 30, priority: 8, is_sleep: false },
    { id: 'sl_lunch', act_id: 'eating', label: 'Lunch', emoji: '🥗', win_start: 12, win_end: 14, dur_min: 20, dur_max: 45, priority: 7, is_sleep: false },
    { id: 'sl_dinner', act_id: 'eating', label: 'Dinner', emoji: '🍜', win_start: 18, win_end: 21, dur_min: 20, dur_max: 50, priority: 7, is_sleep: false },
  ],
  weekend_slots: [
    { id: 'sl_sleep_we', act_id: 'sleep', label: 'Sleep In', emoji: '🌙', win_start: 22, win_end: 32, dur_min: 420, dur_max: 540, priority: 10, is_sleep: true },
    { id: 'sl_wake_we', act_id: 'morning_routine', label: 'Morning', emoji: '🌅', win_start: 8, win_end: 11, dur_min: 20, dur_max: 40, priority: 9, is_sleep: false },
    { id: 'sl_brunch', act_id: 'eating', label: 'Brunch', emoji: '🥞', win_start: 10, win_end: 13, dur_min: 30, dur_max: 60, priority: 8, is_sleep: false },
    { id: 'sl_dinner_we', act_id: 'eating', label: 'Dinner', emoji: '🍜', win_start: 18, win_end: 22, dur_min: 25, dur_max: 60, priority: 7, is_sleep: false },
  ],
  float_activities: [
    { id: 'work', name: 'Working', emoji: '💻', cat: 'productive', availability: 'weekday', dur: [45, 120], base: 0.55, hourly_weights: { 8: 2, 9: 5, 10: 6, 11: 5, 13: 5, 14: 5, 15: 4, 16: 3 }, sat: { purpose: 0.007 }, cost: { energy: -0.002, hunger: -0.001 }, place_key: 'office', location_type: 'commercial', legacy_ids: ['working'] },
    { id: 'exercise', name: 'Exercise', emoji: '🏃', cat: 'active', availability: 'any', dur: [30, 75], base: 0.25, hourly_weights: { 6: 2, 7: 3, 8: 3, 17: 3, 18: 4, 19: 3 }, sat: { fun: 0.007, purpose: 0.005 }, cost: { energy: -0.003, hunger: -0.003, thirst: -0.005 }, place_key: 'gym', location_type: 'recreation', legacy_ids: ['gym'] },
    { id: 'social', name: 'Socializing', emoji: '💬', cat: 'social', availability: 'any', dur: [20, 90], base: 0.28, hourly_weights: { 10: 1, 12: 2, 17: 3, 18: 4, 19: 4, 20: 3, 21: 2 }, sat: { social: 0.020, fun: 0.006 }, cost: { energy: -0.001 }, place_key: 'bar', location_type: 'social', legacy_ids: ['hanging_out'] },
    { id: 'reading', name: 'Reading', emoji: '📚', cat: 'leisure', availability: 'any', dur: [20, 60], base: 0.30, hourly_weights: { 7: 1, 8: 2, 9: 2, 20: 3, 21: 4, 22: 3 }, sat: { fun: 0.008, purpose: 0.004 }, cost: {}, place_key: 'cafe', location_type: 'social', legacy_ids: [] },
    { id: 'creative', name: 'Creative Work', emoji: '🎨', cat: 'productive', availability: 'any', dur: [30, 90], base: 0.22, hourly_weights: { 9: 2, 10: 3, 11: 3, 14: 2, 20: 3, 21: 3 }, sat: { fun: 0.010, purpose: 0.008 }, cost: { energy: -0.001 }, place_key: 'cafe', location_type: 'social', legacy_ids: [] },
    { id: 'gaming', name: 'Gaming', emoji: '🎮', cat: 'leisure', availability: 'any', dur: [30, 90], base: 0.25, hourly_weights: { 16: 2, 17: 3, 18: 3, 19: 4, 20: 4, 21: 3 }, sat: { fun: 0.015 }, cost: { energy: -0.001 }, place_key: 'home', location_type: 'home', legacy_ids: ['watching_tv'] },
    { id: 'music', name: 'Listening', emoji: '🎵', cat: 'leisure', availability: 'any', dur: [15, 45], base: 0.20, hourly_weights: { 7: 2, 8: 2, 12: 2, 17: 3, 18: 3, 19: 2 }, sat: { fun: 0.006, social: 0.002 }, cost: {}, place_key: 'home', location_type: 'home', legacy_ids: [] },
    { id: 'chores', name: 'Tidying Up', emoji: '🧹', cat: 'routine', availability: 'any', dur: [15, 40], base: 0.18, hourly_weights: { 9: 3, 10: 4, 11: 3, 14: 3, 15: 2 }, sat: { purpose: 0.005 }, cost: { energy: -0.001 }, place_key: 'home', location_type: 'home', legacy_ids: [] },
    { id: 'nap', name: 'Napping', emoji: '😴', cat: 'rest', availability: 'any', dur: [15, 35], base: 0.08, hourly_weights: { 13: 2, 14: 4, 15: 3, 16: 1 }, sat: { energy: 0.003 }, cost: {}, place_key: 'home', location_type: 'home', legacy_ids: [] },
    { id: 'eating', name: 'Eating', emoji: '🍜', cat: 'routine', availability: 'any', dur: [15, 30], base: 0.35, hourly_weights: { 7: 3, 8: 2, 12: 4, 13: 3, 18: 4, 19: 3 }, sat: { hunger: 0.020, thirst: 0.010 }, cost: {}, place_key: 'restaurant', location_type: 'commercial', legacy_ids: [] },
    { id: 'morning_routine', name: 'Morning Routine', emoji: '🌅', cat: 'routine', availability: 'any', dur: [15, 30], base: 0.40, hourly_weights: { 6: 3, 7: 5, 8: 4, 9: 2 }, sat: { purpose: 0.003 }, cost: {}, place_key: 'home', location_type: 'home', legacy_ids: [] },
    { id: 'sleep', name: 'Sleeping', emoji: '🌙', cat: 'rest', availability: 'any', dur: [360, 480], base: 0.01, hourly_weights: { 22: 3, 23: 5, 0: 5, 1: 4, 2: 3, 3: 2, 4: 1, 5: 1 }, sat: { energy: 0.002 }, cost: {}, place_key: 'home', location_type: 'home', legacy_ids: ['sleeping'] },
  ],
  weekend_float_activities: [
    { id: 'day_trip', name: 'Day Trip', emoji: '🚗', cat: 'active', availability: 'weekend', dur: [120, 240], base: 0.35, hourly_weights: { 9: 2, 10: 4, 11: 3, 12: 2 }, sat: { fun: 0.018, social: 0.008 }, cost: { energy: -0.002, hunger: -0.004 }, place_key: 'park', location_type: 'recreation', legacy_ids: [] },
    { id: 'brunch', name: 'Brunch', emoji: '🥞', cat: 'social', availability: 'weekend', dur: [60, 120], base: 0.45, hourly_weights: { 10: 2, 11: 5, 12: 5, 13: 3 }, sat: { hunger: 0.020, social: 0.018, fun: 0.010 }, cost: { energy: -0.001 }, place_key: 'restaurant', location_type: 'social', legacy_ids: [] },
    { id: 'outdoor', name: 'Outdoor Walk', emoji: '🌿', cat: 'active', availability: 'weekend', dur: [45, 90], base: 0.38, hourly_weights: { 9: 2, 10: 4, 11: 4, 12: 3, 14: 3 }, sat: { fun: 0.010, purpose: 0.006 }, cost: { energy: -0.002, thirst: -0.003 }, place_key: 'park', location_type: 'recreation', legacy_ids: [] },
    { id: 'sleep_in', name: 'Sleeping In', emoji: '🛌', cat: 'rest', availability: 'weekend', dur: [30, 90], base: 0.30, hourly_weights: { 7: 3, 8: 4, 9: 4, 10: 2 }, sat: { energy: 0.005, fun: 0.004 }, cost: {}, place_key: 'home', location_type: 'home', legacy_ids: [] },
  ],
  activity_aliases: {
    sleeping: 'sleep',
    working: 'work',
    gym: 'exercise',
    hanging_out: 'social',
    watching_tv: 'gaming',
  },
};

const LEGACY_ACTIVITY_OVERRIDES = {
  sleeping: { label: 'Sleeping', emoji: '😴', locationType: 'home', placeKey: 'home' },
  working: { label: 'Working', emoji: '💼', locationType: 'commercial', placeKey: 'office' },
  gym: { label: 'Working out', emoji: '🏋️', locationType: 'recreation', placeKey: 'gym' },
  hanging_out: { label: 'Hanging out', emoji: '🎉', locationType: 'social', placeKey: 'bar' },
  watching_tv: { label: 'Watching TV', emoji: '📺', locationType: 'home', placeKey: 'home' },
};

const UI_ONLY_ACTIVITIES = {
  grocery: {
    label: 'Getting groceries',
    emoji: '🛒',
    locationType: 'commercial',
    placeKey: 'grocery',
    minDuration: 8000,
    maxDuration: 14000,
    timeOfDayBias: [9, 10, 11, 16, 17, 18],
  },
  commuting: {
    label: 'Commuting',
    emoji: '🚶',
    locationType: 'transit',
    placeKey: null,
    minDuration: 8000,
    maxDuration: 12000,
    timeOfDayBias: [7, 8, 9, 17, 18],
  },
};

function cloneValue(value) {
  if (Array.isArray(value)) {
    return value.map((entry) => cloneValue(entry));
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key, cloneValue(entry)])
    );
  }
  return value;
}

function normalizeSlot(slot) {
  return {
    id: slot.id,
    actId: slot.act_id ?? slot.actId,
    label: slot.label,
    emoji: slot.emoji,
    winStart: slot.win_start ?? slot.winStart,
    winEnd: slot.win_end ?? slot.winEnd,
    durMin: slot.dur_min ?? slot.durMin,
    durMax: slot.dur_max ?? slot.durMax,
    priority: slot.priority ?? 0,
    isSleep: slot.is_sleep ?? slot.isSleep ?? false,
  };
}

function toHourWeights(activity) {
  if (Array.isArray(activity.hw)) {
    return activity.hw.slice(0, 24);
  }
  const source = activity.hourly_weights ?? activity.hourlyWeights ?? {};
  const pairs = Object.entries(source).map(([hour, value]) => [Number(hour), Number(value)]);
  return hw(pairs);
}

function normalizeActivity(activity) {
  const dur = Array.isArray(activity.dur) ? activity.dur : [20, 40];
  return {
    id: activity.id,
    name: activity.name,
    emoji: activity.emoji,
    cat: activity.cat,
    availability: activity.availability ?? 'any',
    dur: [Number(dur[0] ?? 20), Number(dur[1] ?? 40)],
    base: Number(activity.base ?? 0.2),
    hw: toHourWeights(activity),
    sat: cloneValue(activity.sat ?? {}),
    cost: cloneValue(activity.cost ?? {}),
    placeKey: activity.place_key ?? activity.placeKey ?? null,
    locationType: activity.location_type ?? activity.locationType ?? null,
    legacyIds: Array.isArray(activity.legacy_ids ?? activity.legacyIds)
      ? [...(activity.legacy_ids ?? activity.legacyIds)]
      : [],
  };
}

function buildActivityDisplay(activity) {
  return {
    label: activity.name,
    emoji: activity.emoji,
    locationType: activity.locationType ?? inferLocationType(activity.placeKey),
    placeKey: activity.placeKey ?? inferPlaceKey(activity.locationType),
    minDuration: Math.round((activity.dur?.[0] ?? 20) * 60000),
    maxDuration: Math.round((activity.dur?.[1] ?? 40) * 60000),
    timeOfDayBias: activity.hw
      .map((value, hour) => ({ value, hour }))
      .filter((entry) => entry.value > 0)
      .map((entry) => entry.hour),
  };
}

function inferLocationType(placeKey) {
  switch (placeKey) {
    case 'office':
    case 'restaurant':
    case 'grocery':
      return 'commercial';
    case 'gym':
    case 'park':
      return 'recreation';
    case 'bar':
    case 'cafe':
      return 'social';
    case null:
      return 'transit';
    case 'home':
    default:
      return 'home';
  }
}

function inferPlaceKey(locationType) {
  switch (locationType) {
    case 'commercial':
      return 'office';
    case 'recreation':
      return 'park';
    case 'social':
      return 'bar';
    case 'home':
      return 'home';
    default:
      return null;
  }
}

function buildRuntimeCatalog(sourceCatalog) {
  const weekdaySlots = (sourceCatalog.weekday_slots ?? sourceCatalog.weekdaySlots ?? [])
    .map(normalizeSlot);
  const weekendSlots = (sourceCatalog.weekend_slots ?? sourceCatalog.weekendSlots ?? [])
    .map(normalizeSlot);
  const floatActivities = (
    sourceCatalog.float_activities ?? sourceCatalog.floatActivities ?? []
  ).map(normalizeActivity);
  const weekendFloatActivities = (
    sourceCatalog.weekend_float_activities ??
    sourceCatalog.weekendFloatActivities ??
    []
  ).map(normalizeActivity);
  const allActivities = [...floatActivities, ...weekendFloatActivities];
  const activityById = new Map(allActivities.map((activity) => [activity.id, activity]));
  const activityAliases = {
    ...(sourceCatalog.activity_aliases ?? sourceCatalog.activityAliases ?? {}),
  };

  allActivities.forEach((activity) => {
    activity.legacyIds.forEach((legacyId) => {
      if (!activityAliases[legacyId]) {
        activityAliases[legacyId] = activity.id;
      }
    });
  });

  const displayMap = {};
  allActivities.forEach((activity) => {
    displayMap[activity.id] = buildActivityDisplay(activity);
  });

  Object.entries(activityAliases).forEach(([legacyId, canonicalId]) => {
    const canonical = displayMap[canonicalId];
    if (!canonical) {
      return;
    }
    displayMap[legacyId] = {
      ...canonical,
      ...(LEGACY_ACTIVITY_OVERRIDES[legacyId] || {}),
    };
  });

  Object.entries(UI_ONLY_ACTIVITIES).forEach(([activityId, config]) => {
    displayMap[activityId] = { ...config };
  });

  return {
    weekdaySlots,
    weekendSlots,
    floatActivities,
    weekendFloatActivities,
    allActivities,
    activityById,
    activityAliases,
    displayMap,
  };
}

let runtimeCatalog = buildRuntimeCatalog(DEFAULT_SOURCE_CATALOG);

export function installLifeSimCatalog(sourceCatalog) {
  runtimeCatalog = buildRuntimeCatalog(sourceCatalog || DEFAULT_SOURCE_CATALOG);
  return runtimeCatalog;
}

export function resetLifeSimCatalog() {
  runtimeCatalog = buildRuntimeCatalog(DEFAULT_SOURCE_CATALOG);
  return runtimeCatalog;
}

export function getLifeSimCatalog() {
  return runtimeCatalog;
}

export function getDefaultWeekdaySlots() {
  return runtimeCatalog.weekdaySlots;
}

export function getDefaultWeekendSlots() {
  return runtimeCatalog.weekendSlots;
}

export function getDefaultFloatActivities() {
  return runtimeCatalog.floatActivities;
}

export function getDefaultWeekendFloatActivities() {
  return runtimeCatalog.weekendFloatActivities;
}

export function getCanonicalActivityId(activityId) {
  if (!activityId || typeof activityId !== 'string') {
    return null;
  }
  return runtimeCatalog.activityAliases[activityId] || activityId;
}

export function getActivityDefinition(activityId) {
  const canonicalId = getCanonicalActivityId(activityId);
  if (!canonicalId) {
    return null;
  }
  return runtimeCatalog.activityById.get(canonicalId) || null;
}

export function getActivityDisplay(activityId) {
  if (!activityId || typeof activityId !== 'string') {
    return null;
  }
  const direct = runtimeCatalog.displayMap[activityId];
  if (direct) {
    return direct;
  }
  const resolved = getActivityDefinition(activityId);
  if (!resolved) {
    return null;
  }
  return buildActivityDisplay(resolved);
}

export function getActivityPlaceKey(activityId) {
  const display = getActivityDisplay(activityId);
  return display?.placeKey ?? null;
}

export function getActivityLocationType(activityId) {
  const display = getActivityDisplay(activityId);
  return display?.locationType ?? null;
}

const ACTIVITIES_PROXY = {};

export const ACTIVITIES = new Proxy(ACTIVITIES_PROXY, {
  get(_target, prop) {
    if (typeof prop !== 'string') {
      return undefined;
    }
    return runtimeCatalog.displayMap[prop];
  },
  ownKeys() {
    return Reflect.ownKeys(runtimeCatalog.displayMap);
  },
  has(_target, prop) {
    return typeof prop === 'string' && prop in runtimeCatalog.displayMap;
  },
  getOwnPropertyDescriptor(_target, prop) {
    if (typeof prop !== 'string') {
      return undefined;
    }
    const value = runtimeCatalog.displayMap[prop];
    if (!value) {
      return undefined;
    }
    return {
      configurable: true,
      enumerable: true,
      value,
      writable: false,
    };
  },
});
